import React from 'react';
import { Stack, Paper, Typography, Avatar, Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import AIIcon from '@mui/icons-material/SmartToy';
import Markdown from 'react-markdown';

function MessageBubble({ message }) {
    const formatTimestamp = (timestamp) => {
        return timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const isUser = message.role === 'user';
    
    return (
        <Stack
            direction={isUser ? 'row-reverse' : 'row'}
            spacing={1}
            alignItems="flex-start"
            sx={{ mb: 2 }}
        >
            <Avatar
                sx={{
                    width: 32,
                    height: 32,
                    bgcolor: isUser ? 'primary.main' : message.isError ? 'error.main' : 'grey.300'
                }}
            >
                {isUser ? <PersonIcon fontSize="small" /> : <AIIcon fontSize="small" />}
            </Avatar>
            
            <Paper
                elevation={1}
                sx={{
                    px: 2,
                    py: 1,
                    maxWidth: '75%',
                    bgcolor: isUser 
                        ? 'primary.main' 
                        : message.isError 
                            ? 'error.light' 
                            : 'grey.50',
                    color: isUser ? 'white' : 'text.primary',
                    borderRadius: isUser ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
                    position: 'relative'
                }}
            >
                <Box>
                    <Markdown>{message.content}</Markdown>
                </Box>
                <Typography
                    variant="caption"
                    sx={{
                        display: 'block',
                        mt: 1,
                        opacity: 0.7,
                        fontSize: '0.75rem'
                    }}
                >
                    {formatTimestamp(message.timestamp)}
                </Typography>
            </Paper>
        </Stack>
    );
}

export default MessageBubble;

